import { formatPointsByLocale, } from "@alk/numbers";
import { h } from "@stencil/core";
import { getPointsSize } from "./fnx-pricing-points.utils";
const DEFAULT_DECIMAL_AMOUNT = 2;
const DEFAULT_FALLBACK_VALUE = '--';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const FnxPricingPoints = ({ points, fallbackValue }) => {
  var _a;
  const formateLocal = formatPointsByLocale(navigator.language);
  const dAmount = (_a = points === null || points === void 0 ? void 0 : points.ExtraDigits) !== null && _a !== void 0 ? _a : DEFAULT_DECIMAL_AMOUNT;
  const fallValue = fallbackValue !== null && fallbackValue !== void 0 ? fallbackValue : DEFAULT_FALLBACK_VALUE;
  const textToShow = !Boolean(points) || isNaN(points.Value) ?
    fallValue :
    formateLocal(dAmount)(points.Value);
  return (h("p", { class: `fnx-princing-points ${getPointsSize(textToShow === null || textToShow === void 0 ? void 0 : textToShow.length)}` }, !Boolean(points) || isNaN(points.Value) ?
    fallValue :
    textToShow));
};
//# sourceMappingURL=fnx-pricing-points.js.map
